import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useWait } from '~/composables/_next/useWait';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import { useUser } from '~/composables/_next/useUser';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzPaymentInfos from '~/components/_next/molecules/AzPaymentInfos.vue';
import Toaster from '~/components/Layout/Toaster.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  name: 'Cart',
  components: {
    FaqChatTrigger: function FaqChatTrigger() {
      return import('~/components/Layout/FaqChatTrigger.vue');
    },
    Toaster: Toaster,
    NuxtLinkCustom: NuxtLinkCustom,
    AzIcon: AzIcon,
    AzPaymentInfos: AzPaymentInfos
  },
  setup: function setup() {
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      $sentry = _useNuxt2App.$sentry,
      $flag = _useNuxt2App.$flag,
      $cookies = _useNuxt2App.$cookies,
      $config = _useNuxt2App.$config;
    var _useUser = useUser(),
      loadUser = _useUser.load,
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var _useWait = useWait(),
      resetWaiters = _useWait.resetWaiters;
    var _useCustomerGroup = useCustomerGroup(),
      setCustomerGroup = _useCustomerGroup.setCustomerGroup,
      removeCustomerGroup = _useCustomerGroup.removeCustomerGroup;
    resetWaiters();
    var mounted = ref(false);
    var iAdvizeEnabled = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadUser();
          case 2:
            if (user.value) {
              sendSentryContext(user.value);
            }
            sendTgglContext(user.value);
            iAdvizeEnabled.value = $flag.get('iAdvizeEnabled');
            mounted.value = true;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(isAuthenticated, function (newValue, oldValue) {
      if (newValue === oldValue) return;
      if (!newValue) {
        removeCustomerGroup();
      } else {
        var _user$value;
        setCustomerGroup((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.customerGroup);
      }
    });

    /**
     * Sends context data to sentry.
     */
    function sendSentryContext(user) {
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.setUser({
        id: user === null || user === void 0 ? void 0 : user.id,
        email: user === null || user === void 0 ? void 0 : user.email,
        externalId: user === null || user === void 0 ? void 0 : user.externalId
      });
    }
    var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
      setIsTalonOneEnabled = _useFeatureFlagTalonO.setIsTalonOneEnabled;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale,
      country = _useLocalization.country;

    /**
     * Sends context data to Tggl.
     */
    function sendTgglContext(_x) {
      return _sendTgglContext.apply(this, arguments);
    }
    function _sendTgglContext() {
      _sendTgglContext = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(user) {
        var _user$id, _user$customerGroup;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return $flag.setContext({
                environment: process.env.CURRENT_ENV,
                userId: (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : $cookies.get('az_uuid'),
                email: user === null || user === void 0 ? void 0 : user.email,
                externalId: user === null || user === void 0 ? void 0 : user.externalId,
                customerGroup: user === null || user === void 0 ? void 0 : (_user$customerGroup = user.customerGroup) === null || _user$customerGroup === void 0 ? void 0 : _user$customerGroup.key,
                locale: locale,
                country: country
              });
            case 2:
              setIsTalonOneEnabled($flag.get('enableTalonOne'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _sendTgglContext.apply(this, arguments);
    }
    useHead(function () {
      return {
        title: 'Aroma-Zone',
        script: [{
          src: "https://maps.googleapis.com/maps/api/js?key=".concat($config.public.googlePlaceToken, "&libraries=places&language=").concat(locale),
          body: true
        }]
      };
    });
    return {
      route: route,
      iAdvizeEnabled: iAdvizeEnabled,
      mounted: mounted
    };
  }
});